import { render, staticRenderFns } from "./RatingsLogo.vue?vue&type=template&id=bc51a80a&scoped=true"
import script from "./RatingsLogo.vue?vue&type=script&lang=js"
export * from "./RatingsLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc51a80a",
  null
  
)

export default component.exports